require("payments/purchase_order_input.scss");

class PurchaseOrderInput extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onChange(key, e) {
		var updatedValues = _.extend({}, this.props.values, {
			[key]: e.target.value
		})
		this.props.onChange(updatedValues);
	}

	render() {
		return (
			<div className="purchaseOrderInput">
				<label className="contactInfoField">
					<span>Accounts payable full name</span>
					<input type="text" className="form-control"
						value={ this.props.values["payable_name"] || "" }
						onChange={ this.onChange.bind(this, "payable_name") } />
				</label>
				<label className="contactInfoField">
					<span>Accounts payable email</span>
					<input type="text" className="form-control"
						value={ this.props.values["payable_email"] || "" }
						onChange={ this.onChange.bind(this, "payable_email") } />
				</label>
				<label className="contactInfoField">
					<span>Accounts payable phone</span>
					<input type="text" className="form-control"
						value={ this.props.values["payable_phone"] || "" }
						onChange={ this.onChange.bind(this, "payable_phone") } />
				</label>
				<label className="contactInfoField">
					<span>Comments (optional)</span>
					<input type="text" className="form-control"
						placeholder="More than one teacher? Other questions?"
						value={ this.props.values["comments"] || "" }
						onChange={ this.onChange.bind(this, "comments") } />
				</label>
			</div>
		);
	}

};

PurchaseOrderInput.propTypes = StrictPropTypes({
	values: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired
});

module.exports = PurchaseOrderInput;



// WEBPACK FOOTER //
// ./modules/components/payments/PurchaseOrderInput.js